<template>
  <div class="affixDoc">
    <el-form :model="item" status-icon ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm">
      <el-form-item  prop="pass" class="single-row">
        <!-- label slot -->
        <span slot="label" :title="name" :alt="name" class="label-wrap">
            {{ item.hideLable?'':( name ? ( name + '：') : '附件信息：' )}}
        </span>
          <p>{{item.name}}</p>
          <div class="upload" >
            <em  v-show="this.item.filePath" class="el-icon-view" @click="fileView(item)"></em>
            <em  v-show="this.item.filePath" class="el-icon-download" style="margin-left:10px" @click="fileDownload(item)"></em>
            <el-button v-show="this.item.filePath && filingCBtn"
                       type="primary"
                       size="mini"
                       style="margin-left:10px"
                       @click="onClickSign(item)"
            >
              签章
            </el-button>
<!--              -->
<!--             <a :download="item.name" :href="url" v-show="item.id"><em class="el-icon-download"></em></a>-->
          </div>
      </el-form-item>
    </el-form>
      <el-dialog :visible.sync="imgDialogVisible" :modal="showModal" width="100%" height="100%" @closed="dialogClose" :modal-append-to-body="false">
          <img :src="filePath" alt="" @contextmenu.prevent=""  class="viewImg">
      </el-dialog>
      <el-dialog title="PDF签章页面" :visible.sync="dialogVisible" :modal="showModal" :modal-append-to-body="false">
        <el-radio-group v-model="signType">
          <el-radio label="1">介质CA</el-radio>
          <el-radio label="2">移动CA</el-radio>
        </el-radio-group>
        <template slot="footer">
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleBtnSelectSignFn">确 定</el-button>
        </template>
      </el-dialog>
      <!-- 移动CA dialog -->
      <el-dialog title="移动CA签章页面" :visible.sync="caVisible" width="1180px" :modal-append-to-body="false">
        <div class="ca_container">
          <template v-if="!isIe">
            <el-button type="primary" @click="showAipWnd(1)">显示窗口最大</el-button>
            <el-button type="primary"  @click="showAipWnd(9)">显示窗口居中</el-button>
            <el-button type="primary" @click="exAddSealFn">手动盖章</el-button>
            <el-button type="primary" @click="addMultSeal">手动多页盖章</el-button>
            <el-button type="primary" @click="getnotenums">获取签章个数</el-button>
            <el-button type="primary" @click="saveFileHandle">保存服务器</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="getIeBxtSealNum(true)">获取签章个数</el-button>
            <el-button type="primary" @click="saveToServer()">保存服务器</el-button>
            <div style="width:1140px;height:500px;margin:10px auto;overflow:scroll;">
                  <object id="HWPostil1" height='100%' width='100%' style='left: 0px; top: 0px;'
                      classid='clsid:FF1FE7A0-0578-4FEE-A34E-FB21B277D563'></object>
            </div>
          </template>
        </div>
      </el-dialog>

      <!-- pm_pdf_container -->
      <el-dialog title="PDF签章页面" :visible.sync="pmPdfVisible" @close="pmPdfVisible = false">
        <div id="pm_pdf_container" style="height: 600px;"></div>
        <template #footer>
          <el-button @click="pmPdfVisible = false">取 消</el-button>
          <el-button type="primary" @click="signWindowSaveClick">确 定</el-button>
        </template>
      </el-dialog>
<!--
      <el-dialog title="PDF签章页面" :visible.sync="iframeVisible">
        <iframe :src="iframUrl" frameborder="0" width="100%" height="500"></iframe>
      </el-dialog> -->
  </div>
</template>

<script>
    import $ from "jquery";
    import {isIEBrowser} from '../../utils/utils';
    import {resetApiInstanceUrl} from "../../server/request";
    import {
        apiAttachmentDownloadFile,
        apiAttachmentGetAttachmentByCiteIdAndFileType, apiAttachmentServerOverWriteFile
    } from "@/packages/server/formRender";
    const PmUtils = require('pm-utils/lib/pm-utils.ie');


    export default {
    name: "index",
    data() {
      return {
          isIe: false,
          url:'',
          imgDialogVisible:false,
          dialogImageUrl:'',
          filePath:'',
          dialogVisible: false,
          pmPdfVisible: false,
          caVisible: false,
          signType: '1',
          // iframeVisible: false,
          iframUrl: '',
          signWindowOptions: {
              url: '', // 待签章的pdf路径
              fileName: '', // 回写的文件名称
              fileIndex: null, // 回写的附件下标
              signSuccess: false, // 签章是否成功
              mustSign: false, // 是否必须签章
          },
          pdfViewer: this.$customFormGlobalConfig.pdfViewUrl ? this.$customFormGlobalConfig.pdfViewUrl : '/pdf/web/viewer.html?file=',
      }
    },
    watch: {
      caVisible: {
        handler(newVal, oldVal) {
          if (newVal) {
            if (this.isIe) {
              setTimeout(() => {
                const fileUploadPath = window.location.origin + this.signWindowOptions.url
                loadFileAndInitLogin(fileUploadPath);
              }, 300);
            }
          }
        },
        immediate: true
      }
    },
    props: {
      index: {
        type: Number,
        required: true
      },
        labelWidth: {
            type: String,
           default:"180px"
        },
      item: {
        type: Object,
        required: true
      },
        showModal: {
            type: Boolean,
            default:true,
        },
      name: {
        type: String,
        required: true
      },
      filingCBtn: {
        type: Boolean,
        default:true,
      },
        handleSignFunc: {
            type: Function,
            require: false,
        },
    },
    methods:{
      IsShow(item){
        var mark = ''
        try {
          mark=item.remark?JSON.parse(item.remark):'';
        } catch(e){
          return false
        }
        if(mark && mark.signatureFlag && mark.signatureFlag==true){
          return true
        }
        return false
      },
      getIeBxtSealNum() {
        window.getSealNum(true)
      },
      saveToServer() {
        const fileUploadServe = `${window.location.origin}/api/bxt/uploadFile.do`
        const _self = this
        window.uploadPdfIE(fileUploadServe, function(data) {
          _self.$emit('updateItem',
                _self.signWindowOptions.fileIndex,
                data.filepath,
              )
            const oldFilePath = _self.signWindowOptions.url
            _self.updateUrl(data.filepath, oldFilePath)
            _self.caVisible = false
        })
      },
        onClickSign(item){
          //支持外部传入处理签章方法
          if(this.handleSignFunc) {
              console.log('handleSignFunc')
              const options = {
                  url: item.filePath,
                  fileName: item.name,
                  fileIndex: this.index,
              }
              this.handleSignFunc(options)
          }else {
              this.dialogVisible = true
              this.signWindowOptions.url = item.filePath
              this.signWindowOptions.fileName = item.name
              this.signWindowOptions.fileIndex = this.index;
          }
      },
      updateUrl(newFile, oldFile){
          apiAttachmentServerOverWriteFile(newFile, oldFile).then(res => {
              if (res.data.code === 200) {
                  this.url = res.data.data
                  this.dialogVisible = false
                  this.pmPdfVisible = false
              }
          })
      },
      signWindowSaveClick() {
        // if(!this.signWindowOptions.signSuccess && this.signWindowOptions.mustSign){
        //   this.$message.error('必签文件未签章不可保存')
        //   return
        // }
        // this.signWindowOptions.sealNum = (this.signPDF && this.signPDF.getSealNum && this.signPDF.getSealNum({isOne: true}) || null)
        const signfileName = this.signWindowOptions.fileName
        const oldFilePath = this.signWindowOptions.url

        const _self = this
        let  params = {
            table: 'signed_file',
            fileName: signfileName,
          }
        this.signPDF.pmUploadHttpPost({
          url: `${window.location.origin}/api/jg/uploadFile.do`,
          pam: params,
          error: (res) => {
            console.log(res, 'error');
          },
          success: (res) => {
            const resData = JSON.parse(res.data) || {}
            if(resData.code == '1'){
              _self.updateUrl(resData.filepath, oldFilePath)
              if(resData.filepath){
                _self.dialogVisible = false
                _self.$emit('updateItem',
                  _self.signWindowOptions.fileIndex,
                  resData.filepath,
                )
                _self.filePath = resData.filepath;
                _self.signWindowOptions.filePath = resData.filepath || '';
                _self.signWindowOptions.signSuccess = true;
                _self.pmPdfVisible = false;
              }else{
                _self.signWindowOptions.signSuccess = false;
              }

            }
          }
        })
      },
      handleBtnSelectSignFn() {
            const url = this.signWindowOptions.url
            const fileName = this.signWindowOptions.fileName
            const val = this.signType
            if (val === '1') {
                this.openJinGePDFSignWindow({
                    url:url, // 待签章的pdf路径
                    fileName:fileName || url, // 回写的文件名称
                    fileIndex: this.index, // 回写的附件下标
                })
            } else {
                this.caVisible = true
            }
        },
        openJinGePDFSignWindow(options) {
            // 判断是不是ie
           if (!isIEBrowser()) {
              this.$message.error('请使用IE浏览器进行签章操作')
              return
           }
            this.signWindowOptions = options
            var type = this.signWindowOptions.url.substr(this.signWindowOptions.url.lastIndexOf(".") + 1);
            var pdfFlag = this.isAssetTypeAnPDF(type);
            if (!pdfFlag) {
                this.$message.error('非PDF文件，不可进行签章操作')
                return
            }

            this.pmPdfVisible = true;


            setTimeout(() => {
              try {
                this.signPDF = new PmUtils.pdf.Jingge();
                this.signPDF.openUrlPDF({url: window.location.origin + this.signWindowOptions.url})
              } catch (e) {
                this.$message.error('请安装金格PDF插件')
                return
              }
            }, 300);



        },
        isAssetTypeAnPDF(type) {
            return type.toLowerCase() === "pdf";
        },
        async showAipWnd(p1) {
          var level=await SetDispidShowWndLevel(2,'','','','');
          var closebtn=await dispidEnableCloseBtn(1,'','','','');
          var showaip=await ShowAipWnd(p1,50,50,'','','','');
        },
        // 手动盖章
        async exAddSealFn() {
          const fileUploadPath = window.location.origin + this.signWindowOptions.url

          const mobileAppKey = process.env.VUE_APP_mobileAppKey
          const mobileAppId = process.env.VUE_APP_mobileAppId

          await CloseDoc(0,'','','','')
          await OpenFile(fileUploadPath)

          const codeurl = process.env.VUE_APP_bxtUrl
          await SetValue("SET_MOBILE_KEYURL", codeurl,"","","","");
          await SetValue("SET_MOBILE_APPKEY", mobileAppKey,"","","","");
          await SetValue("SET_MOBILE_APPID", mobileAppId,"","","","");
          await SetValue("DEL_FORCETYPE_VALUE2","2","","","","");	//去除右键完成盖章操作，完成签名。
          var islogin=await Login("bx", 1, 65535, "bx", "","","","","");	//用户登录
          if (islogin !== 0) {
              console.log(typeof(islogin));
              await ShowMessage("登录失败！返回值为："+parseInt(islogin)+"","提示",0,"","","","");
              return islogin;
          }
        },
        addMultSeal() {
          addMultSeal()
        },
        getnotenums() {
          getnotenums(true)
        },
        saveFileHandle() {
          // const fileUploadServe = `http://192.168.1.109:10280/bxt/uploadFile.do`
          const fileUploadServe = `${window.location.origin}/api/bxt/uploadFile.do`

          SaveToS(1,fileUploadServe,'pdf', (data) => {
            console.log(data, 'saveToS')
            this.$emit('updateItem',
                this.signWindowOptions.fileIndex,
                data.filepath,
              )
            const oldFilePath = this.signWindowOptions.url
            this.updateUrl(data.filepath, oldFilePath)
            this.caVisible = false

          })
        },

      fileView(item){

          // 获取文件类型
          let type = item.name.substr(item.name.lastIndexOf(".")+1);
          let imgFlag = this.isAssetTypeAnImage(type);
          // let videoFlag = this.isAssetTypeAnVideo(type);
          // let audioFlag = this.isAssetTypeAnAudio(type);
          let pdfFlag = this.isAssetTypeAnPDF(type);

          if(pdfFlag){
              window.open(this.pdfViewer + item.filePath, '_blank');
            return
          }

          if(imgFlag){
              apiAttachmentGetAttachmentByCiteIdAndFileType(item.bizId, item.fileType).then(res => {
                  if(res.data.code == '1'){
                      this.filePath = res.data.data.filePath;
                      this.imgDialogVisible = true;
                  }
              })


          }else{

              this.fileDownload(item);

          }



      },
        dialogClose() {
            this.dialogImageUrl = "";
            this.imgDialogVisible = false;
            this.showModal = false;
        },

        isAssetTypeAnCompressed(ext){
            let arr = ['zip','Z', 'rar','sit','sys','tmp','gz','cab','7z'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnImage(ext){
            let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnVideo(ext) {
            let arr = ['mp4', 'rmvb', 'flv', 'mpeg', 'avi', 'mov', 'wmv', 'ram']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnAudio(ext) {
            let arr = ['mp3', 'wav', 'wma', 'ogg', 'ape', 'acc']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnPDF(ext) {
            let arr = ['pdf', 'PDF']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },

      fileDownload(item){
        if(item.filePath){
            apiAttachmentDownloadFile(item.bizId, item.fileType, item.id).then(res => {
              if(res.data.code==='1'){
                  var a = document.createElement('a');
                  a.download = this.item.name;
                  a.target="_Blank";
                  a.href = res.data.data;
                  $("body").append(a);
                  a.click();
                  $(a).remove();

              }else{

                  this.$message({
                      type:'error',
                      message:res.data.msg
                  })

              }

          })
        }
      }
    },
    mounted() {
      const that = this;
      window.addEventListener("message",function(e) {
        if(e.data=='signedSuccess'){
          that.$emit('refreshPdf',true)
        }
      })
      this.isIe = isIEBrowser()
        this.pdfViewer = resetApiInstanceUrl(this.pdfViewer);
      // if (this.isIe) {
      //   setTimeout(() => {
      //     const fileUploadPath = process.env.VUE_APP_uploadUrl + this.signWindowOptions.url
      //     loadFileAndInitLogin(fileUploadPath);
      //   }, 1000);
      // }
    }
  }
</script>

<style lang="less" scoped>
  em{
    cursor: pointer;
  }
  /deep/ .el-form-item__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
